module.exports = __webpack_public_path__ + "static/img/06020D_3_R_20190227_LC.5ad5617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06020D_3_R_20190227_LC.png
// module id = 6Dg3
// module chunks = 0